import React from "react";
import Image from "next/image";
import Link from "next/link";
import { FaArrowRight, FaAward, FaCheckCircle } from "react-icons/fa";

const CallToActionSection = () => {
  return (
    <section className="container mx-auto px-4 md:px-6 py-20 max-w-7xl">
      <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-slate-900">
        
        {/* --- Background Effects --- */}
        <div className="absolute inset-0 bg-gradient-to-br from-teal-900 via-slate-900 to-black opacity-90"></div>
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-teal-500/20 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-blue-500/10 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

        {/* --- Grid Layout --- */}
        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center p-8 md:p-12 lg:p-16">
          
          {/* Left Column: Content */}
          <div className="lg:col-span-7 space-y-8">
            
            {/* Trust Badge Pill */}
            <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/10 rounded-full py-2 pl-2 pr-6 w-fit">
              <div className="bg-white rounded-full p-1.5 w-10 h-10 flex items-center justify-center shadow-lg">
                <Image
                  src="/images/msme.png"
                  width={30}
                  height={30}
                  alt="MSME Logo"
                  className="object-contain"
                />
              </div>
              <div>
                <span className="block text-[10px] text-teal-300 font-bold uppercase tracking-wider leading-none">Government Recognized</span>
                <span className="block text-sm font-bold text-white leading-none mt-1">MSME Certified</span>
              </div>
            </div>

            {/* Headline */}
            <div>
              <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight">
                Validate Your Skills with <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-emerald-400">
                  Global Recognition
                </span>
              </h2>
              <p className="mt-6 text-lg text-slate-300 max-w-xl leading-relaxed">
                Unlock new career opportunities with an official <span className="text-white font-semibold">VIDYASTU</span> certification. Stand out to recruiters with verified credentials.
              </p>
            </div>

            {/* Feature List */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
              <div className="flex items-center gap-2 text-slate-300">
                <FaCheckCircle className="text-teal-400" />
                <span>Lifetime Validity</span>
              </div>
              <div className="flex items-center gap-2 text-slate-300">
                <FaCheckCircle className="text-teal-400" />
                <span>Shareable on LinkedIn</span>
              </div>
            </div>

            {/* CTA Button */}
            <div className="pt-2">
              <Link 
                href="/about" 
                className="group relative inline-flex items-center gap-3 px-8 py-4 bg-white text-slate-900 rounded-full font-bold text-lg shadow-lg hover:shadow-teal-500/25 transition-all duration-300 hover:-translate-y-1 overflow-hidden"
              >
                <span className="relative z-10">Get Certified Now</span>
                <FaArrowRight className="relative z-10 text-teal-600 group-hover:translate-x-1 transition-transform" />
                <div className="absolute inset-0 bg-gradient-to-r from-teal-50 to-white opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
            </div>
          </div>

          {/* Right Column: Visuals */}
          <div className="lg:col-span-5 relative flex justify-center lg:justify-end">
            
            {/* Floating Glow Behind */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-teal-500/30 to-purple-500/30 blur-3xl rounded-full"></div>

            <div className="relative w-full max-w-md perspective-1000">
              
              {/* Main Certificate Image */}
              <div className="relative z-20 transform transition-transform duration-500 hover:scale-[1.02] hover:-rotate-1">
                <div className="absolute -inset-1 bg-gradient-to-r from-teal-400 to-blue-500 rounded-lg blur opacity-30"></div>
                <Image
                  className="relative rounded-lg shadow-2xl border border-white/10 w-full h-auto bg-white"
                  src="/images/certificate.png"
                  width={500}
                  height={350}
                  alt="Certificate Preview"
                  priority
                />
                
                {/* Floating Badge overlay */}
                <div className="absolute -top-6 -right-6 z-30 animate-bounce-slow">
                  <Image
                     src="/images/badge.png"
                     width={100}
                     height={100}
                     alt="Gold Badge"
                     className="drop-shadow-2xl"
                  />
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;